// @flow

import {Typography, makeStyles} from '@material-ui/core';
import React from 'react';
import {colors} from '../../../../../assets/styles/colors';
import CustomButton from '../../../../../elements/CustomButton/CustomButton';

import type {Theme} from '@material-ui/core';

type Props = {
  featureLabel: string,
};

const useStyles = makeStyles((theme: Theme) => ({
  backdrop: {
    top: 0,
    left: 0,
    position: 'absolute',
    width: '100%',
    height: '100%',
    zIndex: 1,
    backgroundColor: 'rgba(184, 184, 199, 0.4)',
    borderRadius: '10px',
  },
  content: {
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  card: {
    padding: theme.spacing(2, 3),
    borderRadius: '10px',
    backgroundColor: '#FFFFFF',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  title: {
    color: colors.grey900,
    fontSize: 14,
    fontWeight: 500,
    textAlign: 'center',
  },
  subtitle: {
    color: colors.grey700,
    fontSize: 14,
    fontWeight: 400,
    textAlign: 'center',
  },
  seePlansBtn: {
    marginTop: theme.spacing(2),
  },
}));

export default function RestrictionModal({featureLabel}: Props) {
  const classes = useStyles();
  return (
    <div className={classes.backdrop}>
      <div className={classes.content}>
        <div className={classes.card}>
          <Typography className={classes.title}>
            {featureLabel} es una función PRO +
          </Typography>
          <Typography className={classes.subtitle}>
            Actualiza tu plan tener mas control
            <br /> de tu personalización
          </Typography>
          <CustomButton variant="contained" className={classes.seePlansBtn}>
            Ver Planes
          </CustomButton>
        </div>
      </div>
    </div>
  );
}
